import React from "react";
import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import Select from "react-select";
import useRequestForm from "./useRequestForm";

const RequestForm = ({ handleClose }) => {
  const {
    formik,
    requestableOptions,
    allFilled,
    canAddMore,
    handleAddRequest,
    handleRemoveRequest,
  } = useRequestForm({ handleClose });

  return (
    <div className="pro-w-100">
      {formik.values.requests.map((req, index) => {
        const touched = formik.touched.requests?.[index];
        const errors = formik.errors.requests?.[index];

        return (
          <div
            key={index}
            className="pro-p-4 pro-mb-4 pro-rounded-3"
            style={{
              border: "1px solid var(--pro-border-color, #dee2e6)",
              position: "relative",
            }}
          >
            {formik.values.requests.length > 1 && (
              <button
                className="pro-btn pro-btn-link pro-p-0"
                onClick={() => handleRemoveRequest(index)}
                style={{ position: "absolute", top: "10px", right: "10px" }}
              >
                <span
                  className="material-symbols-outlined"
                  style={{ color: "red", fontSize: "20px" }}
                >
                  delete
                </span>
              </button>
            )}

            <div className="pro-mb-3">
              <div className="input-wrap">
                <label
                  htmlFor={`document_type_${index}`}
                  className="pro-font-sm pro-mb-1 pro-d-block"
                >
                  Document Type *
                </label>
                <Select
                  inputId={`document_type_${index}`}
                  options={requestableOptions.filter(
                    (opt) =>
                      opt.value === req.document_type ||
                      !formik.values.requests.some(
                        (r, i) => i !== index && r.document_type === opt.value
                      )
                  )}
                  value={
                    requestableOptions.find(
                      (opt) => opt.value === req.document_type
                    ) || null
                  }
                  onChange={(opt) =>
                    formik.setFieldValue(
                      `requests[${index}].document_type`,
                      opt?.value || ""
                    )
                  }
                  onBlur={() =>
                    formik.setFieldTouched(
                      `requests[${index}].document_type`,
                      true
                    )
                  }
                  placeholder="Select document type"
                  classNamePrefix="pro-input"
                  className={`pro-input lg ${
                    touched?.document_type && errors?.document_type
                      ? "error"
                      : ""
                  }`}
                  isClearable
                />
                {touched?.document_type && errors?.document_type && (
                  <span className="error-text">{errors.document_type}</span>
                )}
              </div>
            </div>

            <Input
              label="Comment *"
              type="text"
              name={`requests[${index}].comment`}
              value={req.comment}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={`pro-input lg ${
                touched?.comment && errors?.comment ? "error" : ""
              }`}
              error={touched?.comment && errors?.comment}
              errorMessage={errors?.comment}
            />
          </div>
        );
      })}

      {canAddMore && (
        <Button
          className="pro-btn-outline lg pro-w-100 pro-mb-4"
          onClick={handleAddRequest}
        >
          <span className="material-symbols-outlined pro-me-1">add</span>
          Add More
        </Button>
      )}

      <div className="col-12 pro-d-flex pro-justify-end offcanvas-footer-sticky-btns">
        <Button className="pro-btn-link lg pro-px-5" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          className={`pro-btn-primary lg pro-ms-3 ${
            !allFilled ? "disabled" : ""
          }`}
          type="button"
          onClick={formik.handleSubmit}
          disabled={!allFilled}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default RequestForm;
